
// 画像を選択時にプレビューする
// function previewImage(event:any) {

//     const fileReader = new FileReader();
//     const elem = event.currentTarget;

//     fileReader.onload = () => {
//         const previewWindow = elem.parentElement.querySelector('.preview-window');
//         previewWindow.src = fileReader.result;
//     };
//     fileReader.readAsDataURL(event.target.files[0]);
// }

// const backgroundInput = document.getElementById("backgroundInput")
// const avaterInput = document.getElementById("avaterInput");

// backgroundInput!.addEventListener("change", previewImage);
// avaterInput!.addEventListener("change", previewImage);


export default{
    //[duplicated] 「shared-space」はdata.sqlでも同じ値が定義されているので、変更する時は一緒に変更すること！
    ANONYMOUS_USER_NAME: "shared-space",

    //[duplicated] 同名の変数をバック側、KIWI側（API）にも定義しているので、値を変える場合は一緒に変更すること
    userNameMaxLen:30,
    userDisplayNameMaxLen:40,
    passwordMinLen: 8,
    passwordMaxLen: 64,
    hashedPasswpordMaxLen:60,
    
    profileSelfIntroductionMaxLen:3000,
    profileLocationMaxLen:200,

    commnentMaxLen:1000,
    publicPagePathMaxLen: 200,
    publicPageDescriptionMaxLen:3000,    
    publicPageTitleMaxLen:100, //mysqlのvarcharでユニーク（indexも？）の上限が3072 bytes。
        
    publicPageLayoutSizeMin:1,  
    publicPageLayoutSizeMax:9999,  

    urlMaxLen:2048, //httpのgetが2048上限らしい
    imagePathMaxLen:200, //URLの一部として使われる。フォルダ階層含めるがシステム側で決めるのでそこまで必要ないだろう。
    mailAddressMaxLen:320, //320で確定らしい
    ipV6MaxLen:46,


    //[duplicated] 同名の変数をKIWI側（Back・Front）にも定義しているので、値を変える場合は一緒に変更すること
    KIWI_UPLOAD_FROM_IFRAME: "upload-from-iframe",
    

};


export const TIMELINE_PERSONALIZED = 0;
export const TIMELINE_NEW = 1;
export const TIMELINE_POPULAR = 2;
export type TIMELINE = typeof TIMELINE_PERSONALIZED | typeof TIMELINE_NEW | typeof TIMELINE_POPULAR;

